var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n2-center-container"},[_c('div',{staticStyle:{"max-width":"600px","margin":"0 auto"}},[_c('signin')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }